<div class="w-full space-y-6 animate-fade-in">
  <!-- Welcome Text -->
  <div class="text-center md:text-left">
    <h2 class="text-2xl font-bold text-greyscale-900 mb-2">
      {{ "resetPasswordPage.chooseNewPassword" | transloco }}
    </h2>
    @if (!isLinkValid) {
      <div class="mt-4 rounded border-l-4 border-error-400 bg-error-50 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <i class="pi pi-exclamation-triangle text-error-400"></i>
          </div>
          <div class="ml-3">
            <p class="text-sm text-error-700">
              {{ linkErrorKey | transloco }}
            </p>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Form -->
  <form
    class="w-full flex flex-col gap-4"
    [formGroup]="passwordForm"
    (ngSubmit)="sendNewPassword()"
  >
    <!-- New Password -->
    <div class="w-full">
        <label for="newPassword" class="mb-1 block text-sm font-medium text-greyscale-700">
          {{ "resetPasswordPage.newPassword" | transloco }}
        </label>

        <!-- Password strength indicator -->
        <app-password-strength-indicator
          [control]="passwordForm.get('newPassword')!"
          translationPrefix="resetPasswordPage">
        </app-password-strength-indicator>

        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-lock" />
          <input
            id="newPassword"
            [type]="isNewPasswordVisible ? 'text' : 'password'"
            formControlName="newPassword"
            [placeholder]="'resetPasswordPage.newPassword' | transloco"
            class="w-full"
            pInputText
            [class.border-error-500]="
              passwordForm.get('newPassword')?.invalid &&
              passwordForm.get('newPassword')?.touched
            "
          />
          <p-inputIcon
            (click)="toggleNewPasswordVisibility()"
            [ngClass]="isNewPasswordVisible ? 'pi pi-eye-slash' : 'pi pi-eye'"
            class="hover:cursor-pointer"
          />
        </p-iconField>

        @if (passwordForm.get('newPassword')?.errors && passwordForm.get('newPassword')?.touched) {
          <div class="mt-1">
            @if (passwordForm.get('newPassword')?.errors?.['required']) {
              <small class="text-error-600">
                {{ "validationError.required" | transloco }}
              </small>
            }
            @if (passwordForm.get('newPassword')?.errors?.['passwordStrength']) {
              <small class="text-error-600">
                {{ "validationError.passwordStrength" | transloco }}
              </small>
            }
          </div>
        }
    </div>

    <!-- Confirm Password -->
    <div class="w-full">
        <label for="confirmPassword2" class="mb-1 block text-sm font-medium text-greyscale-700">
          {{ "resetPasswordPage.confirmPassword" | transloco }}
        </label>

        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-lock" />
          <input
            id="confirmPassword2"
            [type]="isConfirmPasswordVisible ? 'text' : 'password'"
            formControlName="confirmPassword"
            [placeholder]="'resetPasswordPage.confirmPassword' | transloco"
            class="w-full"
            pInputText
            [class.border-error-500]="
              passwordForm.get('confirmPassword')?.invalid &&
              passwordForm.get('confirmPassword')?.touched
            "
          />
          <p-inputIcon
            (click)="toggleConfirmPasswordVisibility()"
            [ngClass]="isConfirmPasswordVisible ? 'pi pi-eye-slash' : 'pi pi-eye'"
            class="hover:cursor-pointer"
          />
        </p-iconField>

        @if (passwordForm.get('confirmPassword')?.errors && passwordForm.get('confirmPassword')?.touched) {
          <div class="mt-1">
            @if (passwordForm.get('confirmPassword')?.errors?.['required']) {
              <small class="text-error-600">
                {{ "validationError.required" | transloco }}
              </small>
            }
            @if (notMatchingError) {
              <small class="text-error-600">
                {{ "validationError.notMatching" | transloco }}
              </small>
            }
        </div>
      }
    </div>

    <button
      type="submit"
      [disabled]="!passwordForm.valid || loading || !isLinkValid"
      class="flex w-full justify-center items-center rounded-md border border-transparent bg-primary-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
    >
      @if (loading) {
        <span class="mr-2">
          <i class="pi pi-spinner pi-spin"></i>
        </span>
      } @else {
        <i class="pi pi-check mr-2"></i>
      }
      {{ "resetPasswordPage.confirmNewPassword" | transloco }}
    </button>
  </form>

  <!-- Links -->
  <div class="flex flex-col items-center md:items-start gap-2">
    <a
      class="text-sm font-medium text-primary-600 no-underline hover:text-primary-500 flex items-center"
      routerLink="/auth/login"
    >
      <i class="pi pi-arrow-left mr-2"></i>
      {{ "resetPasswordPage.backToLogin" | transloco }}
    </a>
  </div>

  <!-- Toast Messages -->
  <p-toast></p-toast>
</div>
